
import Vue, { PropType } from "vue";
import { DialogCloseType, DialogI } from "@/types/dialog";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import Btn from "@/components/v2/base/Btn.vue";

// Asked when the first lesson is left halfway (its X or Android back) — see utils/onboardingLessonLeave.ts.
export default Vue.extend({
  name: "OnboardingLessonLeaveDialog",
  components: { BaseDialog, Btn },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  computed: {
    remainingText(): string {
      const count = Number(this.dialog.config.payload?.remaining) || 1;
      // Same pace as the lesson's own subtitle: ~30 s a sentence.
      const minutes = Math.max(1, Math.round((count * 30) / 60));
      return this.$tc("onboardingV2.lesson.leave.text", count, { count, minutes }).toString();
    },
    // "Your answers are saved" only once there is an answer to save.
    anyDone(): boolean {
      return Number(this.dialog.config.payload?.done) > 0;
    },
  },
  methods: {
    answer(leave: boolean) {
      this.dialog.close({ type: DialogCloseType.SUBMITTED, payload: { leave } });
    },
  },
});
